const gtagUA = 'UA-64609832-8'
export default gtagUA



// WEBPACK FOOTER //
// ./src/gtag-ua.js